import React from "react";
import { isWebpSupported } from "react-image-webp/dist/utils";
import { FormattedMessage } from "react-intl";
import Button, { ButtonType } from "../../../../components/Button/Button";
import PublicLayoutContainer from "../../layouts/PublicLayoutContainer/PublicLayoutContainer";
import "./PublicWork.scss";

const PublicWork: React.FC = () => {
  const Section: React.FC<{
    title: React.ReactNode;
    text: React.ReactNode;
  }> = ({ title, text }) => {
    return (
      <div className="public-work__section">
        <div className="public-work__section-title">{title}</div>
        <div className="public-work__section-text">{text}</div>
      </div>
    );
  };

  return (
    <div
      className={`${isWebpSupported() ? "public-work-webp" : "public-work"}`}
    >
      <PublicLayoutContainer>
        <h2 className="public-work__title grotesk-font">
          <FormattedMessage tagName="span" id="home-work-title" />
        </h2>

        <div className="public-work__sections">
          <Section
            title={
              <FormattedMessage tagName="span" id="home-work-section1-title" />
            }
            text={
              <>
                <FormattedMessage
                  tagName="span"
                  id="home-work-section1-text-1"
                />
                <FormattedMessage
                  tagName="span"
                  id="home-work-section1-text-2"
                />
                <FormattedMessage
                  tagName="span"
                  id="home-work-section1-text-3"
                />
                <FormattedMessage
                  tagName="span"
                  id="home-work-section1-text-4"
                />
              </>
            }
          />
          <Section
            title={
              <FormattedMessage tagName="span" id="home-work-section2-title" />
            }
            text={
              <>
                <FormattedMessage
                  tagName="span"
                  id="home-work-section2-text-1"
                />
                <FormattedMessage
                  tagName="span"
                  id="home-work-section2-text-2"
                />
                <FormattedMessage
                  tagName="span"
                  id="home-work-section2-text-3"
                />
                <FormattedMessage
                  tagName="span"
                  id="home-work-section2-text-4"
                />
              </>
            }
          />
        </div>

        <Button
          // anchorTo={CONTACT_US_ID}
          type={ButtonType.SECONDARY}
          className="public-work__button"
          onClick={() => {
            FreshworksWidget("open");
          }}
        >
          <FormattedMessage tagName="span" id="home-work-cta" />
        </Button>
      </PublicLayoutContainer>
    </div>
  );
};

export default PublicWork;
